// Filter configuration for the Leads Dashboard (`Screens/LeadsDashboard`).
// The Leads *Report* screen keeps its own fields in config/reports.js under
// REPORT_FILTERS.leads; the two screens call different endpoints with different
// parameter names, so their field lists are deliberately separate. Only the
// status list below is shared, so both stay in step with the backend enum.

export const LEAD_STATUS_OPTIONS = [
    { label: "Application Created", value: "Application Created" },
    { label: "Interested", value: "Interested" },
    { label: "Open", value: "Open" },
    { label: "Not Interested", value: "Not Interested" },
    { label: "Follow Up", value: "Follow Up" },
];

// Filter fields for the "All Filters" panel on the Leads Dashboard.
// NOTE: every `key` here must match the `leadFilters` state in LeadDashboard.js
// and the query params built in redux/LeadsReducer/action.js. A key that exists
// in only one of those three places silently does nothing.
export const LEAD_DASHBOARD_FILTERS = [
    { key: 'lead_name', label: 'Customer Name', type: 'text', placeholder: 'Search by Customer Name' },
    { key: 'lead_id', label: 'Lead ID', type: 'text', placeholder: 'Search by Lead ID' },
    // Branch options are injected at render time from the active branch list.
    { key: 'branch', label: 'Branch', type: 'multiselect', options: [] },
    { key: 'status', label: 'Status', type: 'multiselect', options: LEAD_STATUS_OPTIONS },
    { key: 'creation_start_date', label: 'Lead Creation Start Date', type: 'date' },
    { key: 'creation_end_date', label: 'Lead Creation End Date', type: 'date' },
];

// Filter keys that hold a list of values rather than a single one.
export const LEAD_MULTI_VALUE_FILTERS = ['status', 'branch'];

// sessionStorage may still hold a single string from before these filters became
// multi-select, so coerce whatever is there into an array.
export const toFilterArray = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    return value ? [value] : [];
};
